import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ConversationsHistoryComponent } from './components/conversations-history/conversations-history.component';
import { IonicModule } from '@ionic/angular';
import { TruncatePipe } from './pipes/truncate.pipe';

@NgModule({
  declarations: [ConversationsHistoryComponent],
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    TruncatePipe
    
  ],
  exports: [
    ConversationsHistoryComponent,
    TruncatePipe
  ],
  providers: [
  ],
})
export class SharedModule { }
